// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Needhelp_modalOverlay__xre1Q","help":"Needhelp_help__wrHBs","helpIcon":"Needhelp_helpIcon__2+fc+","support":"Needhelp_support__Je7t6","close":"Needhelp_close__K7zsk"};